import { Variable } from '@optimus-web/common';
import { ButtonVariant } from '@optimus-web/core';
import { CheckInButton } from '../../../reservationModule/components/CheckInButton';
import ReservationCheckInDialog from '../../../reservationModule/components/SmartDetail/ReservationCheckInDialog';

export interface CustomerReservationCheckinProps extends Variable<ButtonVariant> {
    reservationId: string;
    active: boolean;
    withCheckInButton?: boolean;
    assignedResourceId?: string | null;
    onButtonClick: () => void;
    onClose: () => void;
    onUpdate: () => void;
}

export const CustomerReservationCheckin = ({
    reservationId,
    assignedResourceId,
    variant,
    withCheckInButton,
    active,
    onButtonClick,
    onClose,
    onUpdate,
}: CustomerReservationCheckinProps) => {
    if (!assignedResourceId) return null;

    const onSuccess = () => {
        onUpdate();
        onClose();
    };

    return (
        <>
            {withCheckInButton ? (
                <CheckInButton
                    variant={variant}
                    onClick={onButtonClick}
                    data-test-reservation-check-in={reservationId}
                    type="submit"
                />
            ) : null}
            <ReservationCheckInDialog
                active={active}
                closeDialog={onClose}
                reservationId={reservationId}
                onSuccess={onSuccess}
                assignedResourceId={assignedResourceId}
            />
        </>
    );
};
